const lazy = path => () => import(`./${path}`);

// 发薪管理
export default [
  {
    path: "/test",
    name: "test",
    component: lazy("index"),
    meta: {
      title: "测试列表",
      keepAlive: true // 缓存
    }
  },
  {
    path: "/leaderboard",
    name: "leaderboard",
    component: lazy("leaderboard"),
    meta: {
      title: "步数排行榜",
    }
  },
  {
    path: "/test/dsbridge",
    name: "test",
    component: lazy("dsbridge"),
    meta: {
      title: "测试jsbridge列表",
      keepAlive: true // 缓存
    }
  },
  {
    path: "/test/dsbridge2",
    name: "test",
    component: lazy("dsbridge2"),
    meta: {
      // title: "测试jsbridge列表",
      keepAlive: true // 缓存
    }
  },
  {
    path: "/test/inputfile",
    name: "test",
    component: lazy("inputfile"),
    meta: {
      // title: "测试jsbridge列表",
      keepAlive: true // 缓存
    }
  }
];
